import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	mapData: [],
	mapLoading: false,
	error: null
};

const mapSlice = createSlice({
	name: 'map',
	initialState,
	reducers: {
		// kick off the create flow
		createMap(state) {
			state.mapLoading = true;
			state.error = null;
		},
		// when both POST /maps and PATCH entity succeed
		createMapSuccess(state, action) {
			state.mapLoading = false;
			state.error = null;
			state.mapData.push(action.payload.map);
		},
		// on any error
		createMapError(state, action) {
			state.mapLoading = false;
			state.error = action.payload || true;
		},
		updateMap(state) {
			state.mapLoading = true;
			state.error = null;
		},
		updateMapSuccess(state, action) {
			state.mapLoading = false;
			state.error = null;
			const updatedMap = action.payload.map;
			state.mapData = state.mapData.map((map) => (map.ID === updatedMap.ID ? updatedMap : map));
		},
		updateMapError(state, action) {
			state.mapLoading = false;
			state.error = action.payload || true;
		}
	}
});

export default mapSlice.reducer;
export const mapActions = mapSlice.actions;
